// countries for which we collect telemetry and offer opt-out
export const TELEMETRY_OPT_OUT_COUNTRIES = new Set([
    'US', // united states
    'AU', // australia
    'IN', // india
    'MX', // mexico
    'NZ', // new zealand
    'NG', // nigeria
    'ZA', // south africa
    'CH', // switzerland
]);
export const DEFAULT_FLUSH_TIMEOUT = 30_000;
